import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default class GemExchangeManagementPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exchanges: [],
            loading: false,
            cursor: null,
            hasMore: true,
            statusFilter: "ALL", // "ALL" hoặc "WAITING_ADMIN"
            uid: "",
            startDate: "",
            endDate: ""
        };
    }

    componentDidMount() {
        this.getExchangeList();
    }

    formatDate = (timestamp) => {
        if (!timestamp) return "-";
        const date = new Date(timestamp);
        const formatter = new Intl.DateTimeFormat('vi-VN', {
            timeZone: 'Asia/Ho_Chi_Minh',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
        return formatter.format(date);
    }

    getStatusBadge = (status) => {
        const statusMap = {
            "WAITING_ADMIN": { class: "warning", text: "Chờ xử lý" },
            "PROCESSED": { class: "success", text: "Đã xử lý" },
            "FAILED": { class: "danger", text: "Thất bại" }
        };
        const statusInfo = statusMap[status] || { class: "secondary", text: status };
        return (
            <span className={`badge badge-${statusInfo.class}`}>
                {statusInfo.text}
            </span>
        );
    }

    getExchangeList = async (cursor = null) => {
        this.setState({ loading: true });
        try {
            const requestBody = {
                cursor: cursor,
            };
            
            // Chỉ thêm status nếu không phải "ALL"
            if (this.state.statusFilter !== "ALL") {
                requestBody.status = this.state.statusFilter;
            }
            
            // Thêm uid nếu có
            if (this.state.uid && this.state.uid.trim()) {
                requestBody.uid = this.state.uid.trim();
            }
            
            // Thêm start date nếu có
            if (this.state.startDate) {
                // Convert date string to timestamp (start of day in Vietnam timezone)
                const startDate = new Date(this.state.startDate + 'T00:00:00+07:00');
                requestBody.start = startDate.getTime();
            }
            
            // Thêm end date nếu có
            if (this.state.endDate) {
                // Convert date string to timestamp (end of day in Vietnam timezone)
                const endDate = new Date(this.state.endDate + 'T23:59:59+07:00');
                requestBody.end = endDate.getTime();
            }
            
            const response = await axios.post(
                `${global.config.apiDomain}/mc-user/referral/web/exchange-to-bank-transactions`,
                requestBody,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data && response.data.status === "OK") {
                const newExchanges = response.data.data?.content || [];
                const newCursor = response.data.data?.cursor;
                
                this.setState(prevState => ({
                    exchanges: cursor ? [...prevState.exchanges, ...newExchanges] : newExchanges,
                    cursor: newCursor,
                    hasMore: newCursor !== "END" && newCursor !== null
                }));
            } else {
                toast.warning(response.data?.message || "Không thể tải danh sách giao dịch");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Đã xảy ra lỗi khi tải danh sách";
            toast.error(errorMessage);
            console.error("Error:", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    handleUpdateStatus = async (gemLogId, isSuccess) => {
        if (!window.confirm(isSuccess ? "Bạn có chắc chắn muốn hoàn thành giao dịch này?" : "Bạn có chắc chắn muốn đánh dấu giao dịch này là thất bại?")) {
            return;
        }

        this.setState({ loading: true });
        try {
            const response = await axios.post(
                `${global.config.apiDomain}/mc-user/referral/web/update-banking-exchange`,
                JSON.stringify({
                    gemLogId: gemLogId,
                    isSuccess: isSuccess
                }),
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data && response.data.status === "OK") {
                toast.success(response.data.message || (isSuccess ? "Cập nhật thành công" : "Đánh dấu thất bại thành công"));
                // Reload danh sách
                this.getExchangeList();
            } else {
                toast.warning(response.data?.message || "Có lỗi xảy ra");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Đã xảy ra lỗi khi cập nhật";
            toast.error(errorMessage);
            console.error("Error:", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    loadMore = () => {
        if (this.state.hasMore && !this.state.loading) {
            this.getExchangeList(this.state.cursor);
        }
    }

    handleStatusFilterChange = (e) => {
        const newFilter = e.target.value;
        this.setState({
            statusFilter: newFilter,
            cursor: null,
            exchanges: [],
            hasMore: true
        }, () => {
            // Reload danh sách với filter mới
            this.getExchangeList();
        });
    }

    handleUidChange = (e) => {
        this.setState({
            uid: e.target.value
        });
    }

    handleStartDateChange = (e) => {
        this.setState({
            startDate: e.target.value
        });
    }

    handleEndDateChange = (e) => {
        this.setState({
            endDate: e.target.value
        });
    }

    handleSearch = () => {
        this.setState({
            cursor: null,
            exchanges: [],
            hasMore: true
        }, () => {
            // Reload danh sách với filter mới
            this.getExchangeList();
        });
    }

    handleClearFilters = () => {
        this.setState({
            uid: "",
            startDate: "",
            endDate: "",
            statusFilter: "ALL",
            cursor: null,
            exchanges: [],
            hasMore: true
        }, () => {
            // Reload danh sách
            this.getExchangeList();
        });
    }

    render() {
        const { exchanges, loading, hasMore, statusFilter, uid, startDate, endDate } = this.state;

        return (
            <div className="container-fluid" style={{ marginTop: "100px", marginBottom: "20px" }}>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">
                                    <i className="fa-solid fa-money-bill-transfer mr-2"></i>
                                    Quản lý Rút Kim Cương - Tiền
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="row mb-3 align-items-end">
                                    <div className="col-md-2">
                                        <label htmlFor="statusFilter" className="mb-1">
                                            <strong>Trạng thái:</strong>
                                        </label>
                                        <select
                                            className="form-control"
                                            id="statusFilter"
                                            value={statusFilter}
                                            onChange={this.handleStatusFilterChange}
                                            disabled={loading}
                                        >
                                            <option value="ALL">Tất cả giao dịch</option>
                                            <option value="WAITING_ADMIN">Giao dịch chưa xử lý</option>
                                            <option value="PROCESSED">Giao dịch đã hoàn thành</option>
                                            <option value="FAILED">Giao dịch thất bại</option>
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="uid" className="mb-1">
                                            <strong>UID:</strong>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="uid"
                                            value={uid}
                                            onChange={this.handleUidChange}
                                            placeholder="Nhập UID"
                                            disabled={loading}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="startDate" className="mb-1">
                                            <strong>Từ ngày:</strong>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="startDate"
                                            value={startDate}
                                            onChange={this.handleStartDateChange}
                                            disabled={loading}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="endDate" className="mb-1">
                                            <strong>Đến ngày:</strong>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="endDate"
                                            value={endDate}
                                            onChange={this.handleEndDateChange}
                                            disabled={loading}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-block"
                                            onClick={this.handleSearch}
                                            disabled={loading}
                                        >
                                            <i className="fa-solid fa-search mr-1"></i>
                                            Tìm kiếm
                                        </button>
                                    </div>
                                    <div className="col-md-2">
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-block"
                                            onClick={this.handleClearFilters}
                                            disabled={loading}
                                        >
                                            <i className="fa-solid fa-times mr-1"></i>
                                            Xóa bộ lọc
                                        </button>
                                    </div>
                                </div>
                                {loading && exchanges.length === 0 ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Đang tải...</span>
                                        </div>
                                        <p className="mt-2">Đang tải dữ liệu...</p>
                                    </div>
                                ) : (
                                    <>
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>UID</th>
                                                        <th>Tên</th>
                                                        <th>Tên tài khoản</th>
                                                        <th>Số tài khoản</th>
                                                        <th>Tên ngân hàng</th>
                                                        <th>Số Tiền</th>
                                                        <th>Trạng thái</th>
                                                        <th>Thời gian</th>
                                                        <th>Hành động</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {exchanges.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="10" className="text-center py-4">
                                                                Không có dữ liệu
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        exchanges.map((exchange) => (
                                                            <tr key={exchange.id}>
                                                                <td>{exchange.id}</td>
                                                                <td>{exchange.uid || "-"}</td>
                                                                <td>{exchange.name || "-"}</td>
                                                                <td>{exchange.accountName || "-"}</td>
                                                                <td>{exchange.accountNumber || "-"}</td>
                                                                <td>{exchange.bankName || "-"}</td>
                                                                <td>{exchange.amount ? exchange.amount.toLocaleString('vi-VN') : "-"}</td>
                                                                <td>{this.getStatusBadge(exchange.status)}</td>
                                                                <td>{this.formatDate(exchange.addTime)}</td>
                                                                <td>
                                                                    {exchange.status === "WAITING_ADMIN" ? (
                                                                        <div className="btn-group" role="group">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-success btn-sm"
                                                                                onClick={() => this.handleUpdateStatus(exchange.id, true)}
                                                                                disabled={loading}
                                                                                title="Hoàn thành"
                                                                            >
                                                                                <i className="fa-solid fa-check mr-1"></i>
                                                                                Hoàn Thành
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-danger btn-sm"
                                                                                onClick={() => this.handleUpdateStatus(exchange.id, false)}
                                                                                disabled={loading}
                                                                                title="Thất bại"
                                                                            >
                                                                                <i className="fa-solid fa-times mr-1"></i>
                                                                                Thất bại
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <span className="text-muted">-</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {hasMore && (
                                            <div className="text-center mt-3">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={this.loadMore}
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                            Đang tải...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa-solid fa-arrow-down mr-2"></i>
                                                            Tải thêm
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

